import { useMemo } from 'react';
import { cleanStringToKebabCase } from '../utils';
import { RepoData } from '../types';

interface UseRepoDataParams {
  projectName: string;
  projectType: string;
  selectedOrganization: string;
  selectedNamespace: string;
  selectedHost: string;
  description: string;
}

/**
 * Hook to calculate repository data
 */
export const useRepoData = ({
  projectName,
  projectType,
  selectedOrganization,
  selectedNamespace,
  selectedHost,
  description,
}: UseRepoDataParams): RepoData => {
  const repositoryName = useMemo(() => {
    if (!projectName || !projectType || !selectedOrganization) {
      return '';
    }

    const cleanName = cleanStringToKebabCase(projectName);
    const cleanType = cleanStringToKebabCase(projectType);

    return `${selectedOrganization}.${cleanType}.${cleanName}`;
  }, [projectName, projectType, selectedOrganization]);

  return useMemo((): RepoData => {
    const repoUrl =
      repositoryName && selectedNamespace
        ? `${selectedHost}?owner=${encodeURIComponent(
            selectedNamespace,
          )}&repo=${encodeURIComponent(repositoryName)}`
        : '';

    return {
      repoUrl,
      projectName,
      projectType,
      repositoryName,
      namespace: selectedNamespace,
      host: selectedHost,
      organization: selectedOrganization,
      description,
    };
  }, [
    repositoryName,
    selectedNamespace,
    selectedHost,
    projectName,
    projectType,
    description,
    selectedOrganization,
  ]);
};
